import { requester } from '@space-shell/config/request'

import { GamificationEndpoints } from './constants'

class GamificationToggleService {
  static async getGamificationToggle(membershipId: string) {
    const { data } = await requester.get<boolean>(
      GamificationEndpoints.gamificationToggle(membershipId)
    )

    return data
  }
}

export default GamificationToggleService
